<div class="report-container">
  
  <iframe name="report-iframe" *ngIf="reportUrl" [src]="reportUrl | safeUrl" class="report-iframe"></iframe>
</div>
